import { noop } from "lodash";
import { useMemo } from "react";
import { constants } from "../constants";

const FULL_DEBUG_ENVS = ["development", "staging", "test"];
const insights = "[insights]";

interface Debug {
  log: (...args: unknown[]) => void;
  debug: (...args: unknown[]) => void;
  info: (...args: unknown[]) => void;
  warn: (...args: unknown[]) => void;
  error: (...args: unknown[]) => void;
}

export const useDebug = (): Debug => {
  const env = constants.RAILS_ENV || "development";
  return useMemo(
    () =>
      FULL_DEBUG_ENVS.includes(env)
        ? {
            log: console.log.bind(console, insights),
            debug: console.debug.bind(console, insights),
            info: console.info.bind(console, insights),
            warn: console.warn.bind(console, insights),
            error: console.error.bind(console, insights),
          }
        : {
            log: noop,
            debug: noop,
            info: noop,
            warn: noop,
            error: console.error.bind(console, insights),
          },
    [env],
  );
};
